import { isMobile } from 'react-device-detect';
import { Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import Block from '../common/Display/Block';
import BlocInformation from './TooltipComponent';
import { useGuaranteedPrice } from '../../hooks/useGuaranteedPrice/useGuaranteedPrice';
import CollapseElement from './CollapseElement';
import { RequestGuaranteedTime } from './RequestGuaranteedTime';
import { GuaranteedInformation } from './GuaranteedInformation';
import { LinkedNcOrders } from './LinkedNcOrders';
import HistoryGaranteedModal from './HistoryGaranteedModal';
import CounterAppraisal from './counterAppraisal/CounterAppraisal';
import { PreEmptOption } from './PreEmptOption';
import { CANCEL_CASE, NRM_SUB_STATUS } from '../../config';
import { t } from '../common/Translate';

function GuaranteedPrice(props) {
  const { recordId } = useParams();
  const {
    firstTooltipOpen,
    secondTooltipOpen,
    thirdTooltipOpen,
    fourthTooltipOpen,
    setFirstTooltipOpen,
    setSecondTooltipOpen,
    setThirdTooltipOpen,
    setFourthTooltipOpen,
    toggleSecond,
    toggleFirst,
    toggleThird,
    fourthToggle,
    firstCollapse,
    secondCollapse,
    thirdCollapse,
    fourthCollapse,
    historyOpen,
    toggleHistory,
    guaranteedPrice,
    firmValuation,
    handleKeepCar,
    supervisor,
    isNrmUser,
    nrmStatusId,
    fifthCollapse,
    toggleFifth,
    fifthTooltipOpen,
    setFifthTooltipOpen,
    isOpenPreEmption,
    setIsOpenPreEmption,
    scrollToPreEmption,
    preEmptRef,
    cancelCaseId,
  } = useGuaranteedPrice(recordId);
  const {
    pricingInProgress,
    noTradeInPriceProposed,
    tradeInWithOrderId,
    tradeInCancelled,
    tradeInMaintainedPriceMaintained,
  } = NRM_SUB_STATUS;
  const showNrmStatusId = ![pricingInProgress, noTradeInPriceProposed].includes(nrmStatusId);
  const { cancelAfterWaitingForCounterAppraisal, cancelAfterWaitingForCounterAppraisalRealDeliveryDate } = CANCEL_CASE;

  return (
    <Block
      {...props}
      backRoute={_.set(props, 'location.state.from', `/files/${recordId}`)}
      showSubHeader
      page={t('guaranteedPrice')}
    >
      <div className="page pricing responsive-page-pricing">
        {guaranteedPrice.length !== 0 && (
          <Row className={`mb-0 justify-content-${showNrmStatusId ? 'between' : 'end'} align-items-center`}>
            {showNrmStatusId && (
              <Col lg="4" md="5" xs="12" sm="5" className="mx-3">
                <p className="mt-3 ml-3 text-primary font-weight-bold">
                  {t('nrmRecordId')} #{guaranteedPrice.nrmRecordId}
                </p>
              </Col>
            )}
            <Col lg="2" md="5" xs="11" sm="5" className="mx-3">
              <button
                type="button"
                data-testid="guaranteed-price-history-btn"
                className="btn btn-block btn-3 custom-padding subtitle"
                onClick={toggleHistory}
              >
                <FontAwesomeIcon icon={faHistory} />
                <span className="d-inline-block d-sm-none d-lg-inline-block ml-2">{t('history')}</span>
              </button>
            </Col>
          </Row>
        )}
        <div className={`mx-3 ${showNrmStatusId ? 'dropdown-padding' : 'my-3'}`}>
          <div>
            <BlocInformation
              handleShowContent={() => setFirstTooltipOpen((prev) => !prev)}
              handleToggle={() => !isMobile && setFirstTooltipOpen((prev) => !prev)}
              tooltipOpen={firstTooltipOpen}
              title={t('requestGuaranteedDescriptionBox')}
              target="Request_guaranteed"
              info={t('requestGuaranteedPrice')}
              dataTestid="request-guaranteed-price-section"
              toggle={toggleFirst}
              collapse={firstCollapse}
            />
            <p className="text-primary">
              <CollapseElement collapse={firstCollapse}>
                <RequestGuaranteedTime />
              </CollapseElement>
            </p>
          </div>
          {guaranteedPrice.length !== 0 && (
            <div>
              <BlocInformation
                handleShowContent={() => setSecondTooltipOpen((prev) => !prev)}
                handleToggle={() => !isMobile && setSecondTooltipOpen((prev) => !prev)}
                tooltipOpen={secondTooltipOpen}
                title={t('guaranteeInformationDescriptionBox')}
                target="Guarantee_Information"
                info={t('guaranteeInformation')}
                dataTestid="guaranteed-information-section"
                toggle={toggleSecond}
                collapse={secondCollapse}
              />
              <p className="text-primary">
                <CollapseElement collapse={secondCollapse}>
                  <GuaranteedInformation toggle={scrollToPreEmption} supervisor={supervisor} />
                </CollapseElement>
              </p>
            </div>
          )}
          {firmValuation.length !== 0 && (
            <div>
              <BlocInformation
                handleShowContent={() => setThirdTooltipOpen((prev) => !prev)}
                handleToggle={() => !isMobile && setThirdTooltipOpen((prev) => !prev)}
                tooltipOpen={thirdTooltipOpen}
                title={t('linkedNCOrdersDescriptionBox')}
                target="Linked_NC_Orders"
                info={t('linkedNCOrders')}
                dataTestid="linked-NC-orders-section"
                toggle={toggleThird}
                collapse={thirdCollapse}
              />
              <p className="text-primary">
                <CollapseElement collapse={thirdCollapse}>
                  <LinkedNcOrders />
                </CollapseElement>
              </p>
            </div>
          )}
          {nrmStatusId === tradeInWithOrderId &&
            supervisor.keepCar === null &&
            supervisor.keepCarDecisionDate !== null &&
            isNrmUser && (
              <div>
                <BlocInformation
                  handleShowContent={() => setFourthTooltipOpen((prev) => !prev)}
                  handleToggle={() => !isMobile && setFourthTooltipOpen((prev) => !prev)}
                  tooltipOpen={fourthTooltipOpen}
                  title={t('preEmptedOptionDescriptionBox')}
                  target="Pre_Empted_Option"
                  info={t('preEmptedOption')}
                  dataTestid="pre-empted-option-section"
                  toggle={fourthToggle}
                  collapse={fourthCollapse}
                />
                <CollapseElement collapse={fourthCollapse}>
                  <div ref={preEmptRef}>
                    <PreEmptOption
                      nrmRecordId={guaranteedPrice.nrmRecordId}
                      handleKeepCar={handleKeepCar}
                      keepCarDecisionDate={supervisor.keepCarDecisionDate}
                      recordId={recordId}
                      isOpenPreEmption={isOpenPreEmption}
                      setIsOpenPreEmption={setIsOpenPreEmption}
                    />
                  </div>
                </CollapseElement>
              </div>
            )}
          {((nrmStatusId === tradeInCancelled &&
            cancelCaseId !== null &&
            ![cancelAfterWaitingForCounterAppraisal, cancelAfterWaitingForCounterAppraisalRealDeliveryDate].includes(
              cancelCaseId,
            ) &&
            supervisor.keepCar !== true) ||
            nrmStatusId >= tradeInMaintainedPriceMaintained) && (
            <div>
              <BlocInformation
                handleShowContent={() => setFifthTooltipOpen((prev) => !prev)}
                handleToggle={() => !isMobile && setFifthTooltipOpen((prev) => !prev)}
                tooltipOpen={fifthTooltipOpen}
                title={t('counterAppraisalInformationDescriptionBox')}
                target="Counter_Appraisal"
                info={t('counterAppraisalInformation')}
                dataTestid="counter-appraisal-information-section"
                toggle={toggleFifth}
                collapse={fifthCollapse}
              />
              <p className="text-primary">
                <CollapseElement collapse={fifthCollapse}>
                  <CounterAppraisal recordId={recordId} />
                </CollapseElement>
              </p>
            </div>
          )}
        </div>

        <HistoryGaranteedModal isOpen={historyOpen} toggle={toggleHistory} />
      </div>
    </Block>
  );
}

export default GuaranteedPrice;
